(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["providoor-story-order-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const guides = document.querySelectorAll('[data-providoor-story-order]');
    if (!guides.length) return;
    const isLive = () => window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode;
    const canMeasure = () => isLive() &&
      window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true &&
      typeof window.Shopify?.analytics?.publish === 'function';
    const publish = (name, guide, extra = {}) => {
      if (!canMeasure()) return false;
      try {
        const result = window.Shopify.analytics.publish(name, {
          article_handle: guide.dataset.storyHandle,
          article_path: guide.dataset.storyPath,
          module_id: 'story_order_guide',
          pilot_version: guide.dataset.pilotVersion,
          ...extra
        });
        if (result && typeof result.catch === 'function') result.catch(() => {});
        return true;
      } catch (error) {
        return false;
      }
    };
    guides.forEach(guide => {
      if (guide.dataset.measurementBound === 'true') return;
      guide.dataset.measurementBound = 'true';
      let visible = false;
      let viewed = false;
      const recordView = () => {
        if (!visible || viewed) return;
        viewed = publish('providoor:story_order_guide_viewed', guide);
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
          recordView();
          if (viewed) observer.disconnect();
        }, { threshold: .25 });
        observer.observe(guide);
      }
      document.addEventListener('visitorConsentCollected', recordView);
      guide.addEventListener('click', event => {
        const link = event.target.closest('a[data-order-link-type]');
        if (!link || !guide.contains(link)) return;
        const destination = new URL(link.href, window.location.origin);
        if (destination.origin !== window.location.origin) return;
        publish('providoor:story_order_guide_clicked', guide, {
          destination_path: destination.pathname,
          destination_type: link.dataset.orderLinkType
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
